export interface ArticleDiscount {
    Description: string;
    Type: number;
    Value: number;
}

export enum ArticleDiscountType {
    Amount = 0,
    Percent = 1,
}

export enum ArticleVatRateType {
    Numeric = 0,
    Exempt = 1,
    Inactive = 2,
}

export type ArticleVatRate = {
    /** null w Value jest dla stawek zwolnionych z VAT */
	Value: number | null,
	VatRateType: ArticleVatRateType,
	VatCode: number | string
};

export type ArticleVatRateObject = {
	[key: string]: ArticleVatRate
};

export type ArticlePaymentMethodObject = {
	[key: string]: string;
};
